import React from 'react';
import { Route } from 'react-router-dom';
import AlertPage from './AlertPage';

export const routes = [<Route key="0" path="/alerts" component={AlertPage} />];

export const navigation = { name: 'alert', link: '/alerts', icon: 'Notiser', parent: 'Members' };
